import { useEffect, useState } from 'react';

import TC_Wrapper from 'react-tag-commander';

import { log } from '@/utils/functions/logger/logger';

type UseTrackingInit = () => { ready: boolean };

const TRACKING_INSTANCE = TC_Wrapper.getInstance();

const useTrackingInit: UseTrackingInit = () => {
  const [tcReady, setTcReady] = useState(false);

  const isTestEnv = import.meta.env.MODE === 'test';

  // Init TC_Wrapper
  const initContainers = async () => {
    try {
      await Promise.all([
        TRACKING_INSTANCE.addContainer('container_body1', import.meta.env.VITE_TAG_COMMANDER_URL_1, 'body'),
        TRACKING_INSTANCE.addContainer('container_body2', import.meta.env.VITE_TAG_COMMANDER_URL_2, 'body'),
      ]);

      setTcReady(true);
    } catch (e) {
      // error
      log.error(`useTrackingInit: Error initializing Tag Commander: ${e}`);
    }
  };

  useEffect(() => {
    initContainers();
  }, []);

  useEffect(() => {
    if (tcReady) {
      TRACKING_INSTANCE.setTcVars({
        env_work: undefined,
        env_country: undefined,
        env_device: undefined,
        env_domaine: undefined,
        page_nom: undefined,
        page_metier: undefined,
        page_template: undefined,
        page_referer: undefined,
        page_categorie_1: undefined,
        page_categorie_2: undefined,
        page_categorie_3: undefined,
        apporteur_id: undefined,
        user_id: undefined,
        user_client: undefined,
        user_connexion: undefined,
        user_statut_contrat: undefined,
      });
      //TODO enable this only in preprod and dev
      // TRACKING_INSTANCE.setDebug(ENV.ENV !== 'PROD');
    }
  }, [tcReady]);

  return { ready: tcReady || isTestEnv };
};

export { TRACKING_INSTANCE, useTrackingInit };
